import { CalendarIcon } from "@components/Icons/CalendarIcon";
import { GalleryIcon } from "@components/Icons/Gallery";
import { UploadIcon } from "@components/Icons/Upload";
import { FC } from "react";
import { useLocation } from "react-router-dom";
import { useEvent, useEventId } from "src/helpers/useEvent";
import { FooterButton } from "./FooterButton";

export const UploaderFooter: FC = () => {
  const location = useLocation();
  const eventId = useEventId();
  const [event] = useEvent();

  // event?.showGuestGalleryTab is deprecated
  const showGuestGalleryTab = event?.mainConfig?.showGuestGalleryTab ?? event?.showGuestGalleryTab ?? false;

  const uploaderSelected = location.pathname.includes("uploader");
  const guestGallerySelected = location.pathname.includes("upload-guest-gallery");
  const eventAgendaSelected = location.pathname.includes("agenda");

  // Show event programme (agenda)
  const isUrbostogos = eventId === "urbostogos";
  const showEventAgenda = isUrbostogos;

  // we hide the UploaderFooter completely if only one (Upload) tab is visible
  if (!showGuestGalleryTab && !showEventAgenda) return null;

  return (
    <footer className="border-grey bottom-0 z-50 h-16 w-full justify-center border-t-0 px-4 pb-4 text-center">
      <div className="flex h-16 justify-center">
        <div className="btm-nav btm-nav-md">
          <FooterButton active={uploaderSelected} href={`/${eventId}/uploader`} data-testid="uploader-footer-btn">
            <UploadIcon />
          </FooterButton>
          {showGuestGalleryTab && (
            <FooterButton
              active={guestGallerySelected}
              href={`/${eventId}/upload-guest-gallery`}
              data-testid="upload-guest-gallery-footer-btn"
            >
              <GalleryIcon />
            </FooterButton>
          )}
          {showEventAgenda && (
            <FooterButton
              active={eventAgendaSelected}
              href={`/${eventId}/agenda`}
              data-testid="event-agenda-footer-btn"
            >
              <CalendarIcon />
            </FooterButton>
          )}
        </div>
      </div>
    </footer>
  );
};
